import {SYSTEM_UPDATE_FILE} from '@/constants/constant';
import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

export const postManualUpdateSW = async (filePath) => {
  const data = {
    file: SYSTEM_UPDATE_FILE,
    filePath,
  };
  const response = await axiosMethods.post(RestAPI.MANUAL_UPDATE_SW, data, null, true, true);
  return response;
};

export const postCancelUpdateSW = async () => {
  const response = await axiosMethods.post(RestAPI.CANCEL_UPDATE_SW);
  return response;
};

export const postInstallUpdateSW = async (data) => {
  const response = await axiosMethods.post(RestAPI.INSTALL_UPDATE_SW, data, null, true, true);
  return response;
};

export const getProgressUpdateSW = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.PROGRESS_UPDATE_SW, null, true, isCatchHandled);
  return response;
};

export const getStatusUpdateSW = async () => {
  const response = await axiosMethods.get(RestAPI.STATUS_UPDATE_SW);
  return response;
};

export const postCheckVersionUpdateSW = async (isCatchHandled = true) => {
  const response = await axiosMethods.post(RestAPI.CHECK_VERSION_UPDATE_SW, null, true, true, isCatchHandled);
  return response;
};
